import { useState } from 'react';
import { TEXT_MUTED, BORDER_DEFAULT, TEXT_HEADING, TEXT_DEFAULT, BG_SURFACE, FIELD_ERROR_BORDER, FONT_LABEL } from '../../theme';

export default function TagEditor({ tags, onChange, placeholder, hasError = false }) {
  const [input, setInput] = useState('');
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingValue, setEditingValue] = useState('');
  const [errorIndex, setErrorIndex] = useState(null);

  const handleKey = (e) => {
    if ((e.key === 'Enter' || e.key === ',') && input.trim()) {
      e.preventDefault();
      onChange([...tags, input.trim()]);
      setInput('');
    }
    if (e.key === 'Backspace' && !input && tags.length > 0) {
      onChange(tags.slice(0, -1));
    }
  };
  const handleBlur = () => {
    const trimmed = input.trim();
    if (trimmed) {
      onChange([...tags, trimmed]);
      setInput('');
    }
  };

  const cancelEdit = () => {
    setEditingIndex(null);
    setEditingValue('');
  };

  const commitEdit = () => {
    if (editingIndex === null) return;
    const trimmed = editingValue.trim();
    if (trimmed === '') { cancelEdit(); return; }
    if (trimmed === tags[editingIndex]) { cancelEdit(); return; }
    if (tags.some((t, i) => i !== editingIndex && t === trimmed)) {
      setErrorIndex(editingIndex);
      setTimeout(() => setErrorIndex(null), 1000);
      cancelEdit();
      return;
    }
    onChange(tags.map((t, i) => i === editingIndex ? trimmed : t));
    cancelEdit();
  };

  const startEdit = (i) => {
    setEditingIndex(i);
    setEditingValue(tags[i]);
  };

  return (
    <div style={{
      display: 'flex', flexWrap: 'wrap', gap: '0.3rem',
      padding: '0.35rem 0.5rem',
      border: `1px solid ${hasError ? FIELD_ERROR_BORDER : BORDER_DEFAULT}`,
      borderRadius: 6,
      background: BG_SURFACE, minHeight: 36, alignItems: 'center',
    }}>
      {tags.map((tag, i) => (
        editingIndex === i ? (
          <input
            key={i}
            autoFocus
            type="text"
            value={editingValue}
            onChange={(e) => setEditingValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') { e.preventDefault(); commitEdit(); }
              else if (e.key === 'Escape') { e.preventDefault(); cancelEdit(); }
            }}
            onBlur={commitEdit}
            style={{
              ...FONT_LABEL,
              background: '#e0e7ef', color: TEXT_DEFAULT, borderRadius: 4,
              padding: '0.15rem 0.5rem',
              border: 'none', outline: 'none',
              width: `${Math.max(editingValue.length + 1, 8)}ch`,
            }}
          />
        ) : (
          <span key={i} onDoubleClick={() => startEdit(i)} style={{
            ...FONT_LABEL,
            background: '#e0e7ef', color: TEXT_DEFAULT, borderRadius: 4,
            padding: '0.15rem 0.5rem',
            display: 'flex', alignItems: 'center', gap: '0.3rem',
            border: errorIndex === i ? `1px solid ${FIELD_ERROR_BORDER}` : undefined,
          }}>
            {tag}
            <button
              type="button"
              onClick={() => onChange(tags.filter((_, j) => j !== i))}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                color: TEXT_MUTED, padding: 0, fontSize: '0.72rem', lineHeight: 1,
              }}
            >✕</button>
          </span>
        )
      ))}
      <input
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKey}
        onBlur={handleBlur}
        placeholder={placeholder}
        style={{
          ...FONT_LABEL,
          border: 'none', outline: 'none', flex: 1, minWidth: 120,
          background: 'transparent', color: TEXT_HEADING,
        }}
      />
    </div>
  );
}
